const Button = ({clickHandle, children, extraClasses = ''}) => {

    return (<button className={`button ${extraClasses}`} onClick={() => clickHandle()}>{children}</button>);
}

export default Button;